<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    scrollable
    dialog-class="modal-color-black select-icon-dialog"
    @hide="onDialogHide"
  >
    <div class="m-4 d-flex flex-direction-row align-items-center justify-content-between">
      <h3 class="m-0">{{ $t('Select an icon from the list') }}</h3>
      <b-icon icon="x" scale="2" :title="$t('Close')" class="cursor-pointer" @click="onCloseClick" />
    </div>

    <div class="m-4">
      <b-custom-input type="text" :label="$t('Filter')" :value="filter" @input="onFilterInput" />
    </div>

    <div class="icon-selector my-4 ml-4 mr-0">
      <div class="icon-selector-grid pr-4">
        <div
          v-for="icon in filteredIcons"
          :key="icon"
          :class="[
            'icon-selector-icon',
            'cursor-pointer',
            'm-1',
            'p-1',
            { 'icon-selector-icon-selected': selectedIcon === icon },
          ]"
          @click="onSelectClick(icon)"
        >
          <custom-icon :icon="icon" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import CustomIcon from './CustomIcon';
import BCustomInput from '@/components/organisation/BCustomInput';

import availableIcons from './bootstrap-icons-v-1.10.5.js';

/** @todo Do we actually need to filter out most of the icons? */
// prettier-ignore
const usedIcons = [
  'trash', 'recycle', 'bricks', 'alarm', 'archive',
  'award', 'bandaid', 'basket', 'bell', 'bicycle', 'book',
  'briefcase', 'brightness-high', 'broadcast', 'brush',
  'bucket', 'building', 'calendar', 'cart', 'clipboard-data',
  'clipboard2-pulse', 'clock', 'cloud', 'cloud-rain', 'cone-striped',
  'cup-straw', 'diagram-2', 'door-closed', 'door-open',
  'droplet', 'ear', 'earbuds', 'exclamation-circle', 'eye-fill',
  'exclamation-triangle-fill', 'eyedropper', 'eyeglasses',
  'fan', 'flag-fill', 'fingerprint', 'hammer', 'headphones',
  'heart-pulse', 'hospital', 'house', 'key', 'life-preserver',
  'lightbulb', 'link', 'lock', 'megaphone', 'minecart',
  'paint-bucket', 'pen', 'pencil', 'person', 'phone',
  'plug', 'printer', 'question-circle', 'router', 'scissors',
  'screwdriver', 'search', 'signpost', 'signpost-2', 'snow',
  'sliders', 'speedometer', 'star', 'star-fill', 'stoplights',
  'thermometer', 'tools', 'truck', 'wrench',
];

export default {
  name: 'SelectIconDialog',

  components: { BCustomInput, CustomIcon },

  props: {
    selectedIcon: {
      type: String,
      default: null,
    },
    visible: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      availableIcons: [...availableIcons],
      filter: null,
    };
  },

  computed: {
    icons() {
      return this.availableIcons.filter((icon) => usedIcons.includes(icon));
    },

    filteredIcons() {
      if (!this.filter) {
        return this.icons;
      }

      const filter = this.filter.toLowerCase();
      return this.icons.filter((icon) => icon.indexOf(filter) !== -1);
    },
  },

  methods: {
    onDialogHide() {
      this.$emit('close');
    },

    onCloseClick() {
      this.$emit('close');
    },

    onSelectClick(selectedIcon) {
      this.$emit('selected', selectedIcon);
    },

    onFilterInput(value) {
      this.filter = value;
    },
  },
};
</script>

<style>
.select-icon-dialog .modal-content {
  max-width: 600px;
}

.select-icon-dialog .modal-body {
  padding: 0;
}
</style>

<style scoped>
.close-button {
  position: absolute;
  top: 24px;
  right: 24px;
}

.icon-selector {
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}
.icon-selector-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(42px + 0.5rem));
  grid-gap: 0.25rem;
  justify-content: space-between;
}

.icon-selector-icon {
  color: var(--bs-secondary);
  border: 1px solid var(--bs-secondary);
  border-radius: 5px;
  font-size: 2rem;
  margin: auto;
}

.icon-selector-icon:hover {
  color: var(--bs-success);
  background-color: #e2e4e5;
}

.icon-selector-icon-selected {
  border: 1px solid var(--bs-success);
  color: var(--bs-success);
}
</style>



// WEBPACK FOOTER //
// src/components/IconSelector/SelectIconDialog.vue